import { useCallback, useContext } from 'react'

import { Context } from '../contexts/Modals'
import { ImageProps } from '../utils/util'
// import {ImageProps} from '../views/Home/components/Question'

const getLargestImage = (img:ImageProps) => {
        if(img.original){
            return img.original.url
        }else{
            return img.large.url
        }
}

export const getLargestImg = (img:ImageProps) => {
    if(img.original){
        return img.original
    }else{
        return img.large
    }
}

export default getLargestImage